/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/

angular.module('bulbApp.bitRateModule')
.service('BulbBitRateService', ['$log', '$q', 'BITRATE', BulbBitRateService]);

/**
 * A utility class to detect a user's bitrate to the S3 servers.  It does this by requesting a small file, and
 * depending on how long that took, requests another file.  It uses the second file to estimate the optimal bitrate
 * for the user.
 *
 * NOTE: This code was written when we were using JSP as our client. I have brought it back and updated it to our current
 * standards.
 *
 * Refer to bitrate.js for test files for which we are going to send to the server.
 *
 */
function BulbBitRateService($log, $q, BITRATE) {

  /**
   * This function times how long it takes to xhr GET a file, starting when the file is actually receiving.  If an
   * error occurs, or if the xhr request times out, it will return the timeout value.
   */
  function timeDownload(file) {

    var timeDeferred = $q.defer();
    var xhr = new XMLHttpRequest();
    // State 4 is when the request has finished.
    var DONE = 4;

    var startTime = new Date().getTime();

    // append a timestamp to ensure fresh data and no caching
    xhr.open('GET', file.url + '?timestamp=' + startTime, true);
    xhr.onreadystatechange = function () {

      if (xhr.readyState === DONE) {
        if (xhr.status === 200) {
          var endTime = (new Date()).getTime();
          var elapsedSeconds = (endTime - startTime) / 1000;
          timeDeferred.resolve(elapsedSeconds);
        } else {
          timeDeferred.reject(xhr.statusText);
        }
      }
    };
    xhr.send();

    return timeDeferred.promise;
  }

  /**
   * This function test a user's connection speed to the server which contains the files specified in our file array.
   * In this case it is testing the connection speed to our S3 servers.  It then determines which of the video
   * qualities that we support would be best and returns it.
   *
   * @param callback A callback function to run after calculating the optimal bitrate for the user. See
   *       jplayer-directive.js 'initializeJplayer' function.
   *
   * @see applicationContext-assets.xml
   *
   */
  this.getOptimalQuality = function(callback) {

    var calculatedBitrate = 0;
    timeDownload(BITRATE.downloadFile).then(function (elapsed) {
      calculatedBitrate = BITRATE.downloadFile.size / elapsed;
      callback(calculatedBitrate);
    }, function (error) {
      $log.error(error);
      callback(BITRATE.defaultOptions.lowerBoundBitrate);
    });

  };

}


